import { onMounted, onBeforeUnmount } from 'vue'

function useResize(fn: (_e?: UIEvent) => void) {
  function sizeChange(e: UIEvent) {
    fn && fn(e)
  }

  onMounted(() => {
    fn && fn()
    window.removeEventListener('resize', sizeChange)
    window.addEventListener('resize', sizeChange)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', sizeChange)
  })
}

export default useResize
